export const getCurrentTimeFromProgress = ({ progress, duration }: { progress: number; duration: number }) => {
  return Math.floor((duration * progress) / 100);
};

export const getProgressFromCurrentTime = ({ currentTime, duration }: { currentTime: number; duration: number }) => {
  return Math.floor((currentTime / duration) * 100);
};
